
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AutomationEventType, OwnershipLevel } from '@fitness-force/enum';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { Observable, catchError, map, throwError } from 'rxjs';
import { AppErrors, BadRequestError, NotFoundError } from '@fitness-force/errors';
import { AutomationByIdResponse, AutomationMaster } from '@fitness-force/models';

@Injectable({
  providedIn: 'root'
})
export class AutomationmasterService {

  constructor(private http: HttpClient, private router: Router) { }
  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  GetAutomationMaster(tenantId:number,eventType: string): Observable<AutomationMaster[]> {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/automation_master/${eventType}`
    return this.http.get(url, {
      headers: this.httpOptions.headers,
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  GetAutomationMasters(): Observable<AutomationMaster[]> {
    const url = `${environment.BASE_URL}/companies/automations/automation_type`
    return this.http.get(url, {
      headers: this.httpOptions.headers,
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  GetAutomationByUuid(uuid:string): Observable<AutomationByIdResponse> {
    const url = `${environment.BASE_URL}/company/automation/${uuid}`
    return this.http.get(url, {
      headers: this.httpOptions.headers,
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  GetCompanyAutomations(): Observable<any[]> {
    const url = `${environment.BASE_URL}/company/automation/ownership/company`
    return this.http.get(url, {
      headers: this.httpOptions.headers,
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  CreateCompanyAutomation(payload: any): Observable<any> {
    const url = `${environment.BASE_URL}/company/automation`
    return this.http.post(url, payload, {
      headers: this.httpOptions.headers,
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  UpdateCompanyAutomation(guid: string, payload: any): Observable<any> {
    const url = `${environment.BASE_URL}/company/automation/${guid}`
    return this.http.put(url, payload, {
      headers: this.httpOptions.headers,
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  MarkAutomationAsActive(guid: string): Observable<any> {
    const url = `${environment.BASE_URL}/company/automation/${guid}/mark_as_active`
    return this.http.put(url, {}, {
      headers: this.httpOptions.headers,
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  MarkAutomationAsInactive(guid: string): Observable<any> {
    const url = `${environment.BASE_URL}/company/automation/${guid}/mark_as_inactive`
    return this.http.put(url, {}, {
      headers: this.httpOptions.headers,
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

}
